// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function useMutationApi(insertAttempt, insertedAttemptId, existingAttemptId, updateActivityCompleted, insertResponse) {
  var match = React.useState(function () {
        
      });
  var setQuestionResult = match[1];
  var questionResult = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setFinished = match$1[1];
  var finished = match$1[0];
  React.useEffect((function () {
          var exit = 0;
          var questionIndex;
          var state;
          var answer;
          var passed;
          var studentActivityAttemptId;
          if (questionResult !== undefined) {
            var passed$1 = questionResult[3];
            var answer$1 = questionResult[2];
            var state$1 = questionResult[1];
            var questionIndex$1 = questionResult[0];
            if (insertedAttemptId !== undefined) {
              if (existingAttemptId === undefined) {
                if (finished) {
                  exit = 1;
                } else {
                  questionIndex = questionIndex$1;
                  state = state$1;
                  answer = answer$1;
                  passed = passed$1;
                  studentActivityAttemptId = insertedAttemptId;
                  exit = 2;
                }
              }
              
            } else if (existingAttemptId !== undefined) {
              if (finished) {
                exit = 1;
              } else {
                questionIndex = questionIndex$1;
                state = state$1;
                answer = answer$1;
                passed = passed$1;
                studentActivityAttemptId = existingAttemptId;
                exit = 2;
              }
            } else if (finished) {
              
            } else {
              Curry._1(insertAttempt, undefined);
            }
          } else {
            exit = 1;
          }
          switch (exit) {
            case 1 :
                if (insertedAttemptId !== undefined) {
                  if (existingAttemptId !== undefined || !finished) {
                    
                  } else {
                    Curry._1(updateActivityCompleted, insertedAttemptId);
                  }
                } else if (existingAttemptId !== undefined && finished) {
                  Curry._1(updateActivityCompleted, existingAttemptId);
                }
                break;
            case 2 :
                Curry._5(insertResponse, studentActivityAttemptId, answer, passed ? 1 : 0, questionIndex, state);
                break;
            
          }
          
        }), [
        questionResult,
        insertedAttemptId,
        finished
      ]);
  var onQuestionPassed = function (question, state, answer) {
    return Curry._1(setQuestionResult, (function (param) {
                  return [
                          question,
                          state,
                          answer,
                          true
                        ];
                }));
  };
  var onQuestionFailed = function (question, state, answer) {
    return Curry._1(setQuestionResult, (function (param) {
                  return [
                          question,
                          state,
                          answer,
                          false
                        ];
                }));
  };
  var onActivityCompleted = function (param) {
    return Curry._1(setFinished, (function (param) {
                  return true;
                }));
  };
  return [
          onQuestionPassed,
          onQuestionFailed,
          onActivityCompleted
        ];
}

var questions = {
  contents: []
};

var stateRef = {
  contents: undefined
};

function clearQuestions(param) {
  questions.contents = [];
  stateRef.contents = undefined;
  
}

function defer(callback, points, question, state, answer) {
  questions.contents = Belt_Array.concat(questions.contents, [[
          answer,
          points,
          question
        ]]);
  stateRef.contents = state;
  return Curry._3(callback, question, state, answer);
}

function useMutationApi$1(insertAttempt, insertedAttemptId, existingAttemptId, updateActivityCompleted, insertResponses, makeResponseObject, upsertActivityState) {
  React.useEffect((function () {
          return (function (param) {
                    return clearQuestions(undefined);
                  });
        }), []);
  var insertResponse = function (studentActivityAttemptId, answer, points, questionIndex, state) {
    
  };
  var updateActivityCompleted$1 = function (studentActivityAttemptId) {
    Curry._1(insertResponses, Belt_Array.map(questions.contents, (function (param) {
                return Curry._4(makeResponseObject, studentActivityAttemptId, param[0], param[1], param[2]);
              })));
    if (Belt_Option.isSome(stateRef.contents)) {
      Curry._2(upsertActivityState, studentActivityAttemptId, stateRef.contents);
    }
    return Curry._1(updateActivityCompleted, studentActivityAttemptId);
  };
  var match = useMutationApi(insertAttempt, insertedAttemptId, existingAttemptId, updateActivityCompleted$1, insertResponse);
  var onQuestionFailed = match[1];
  var onQuestionPassed = match[0];
  var wrappedOnQuestionPassed = function (question, state, answer) {
    return defer(onQuestionPassed, 1, question, state, answer);
  };
  var wrappedOnQuestionFailed = function (question, state, answer) {
    return defer(onQuestionFailed, 0, question, state, answer);
  };
  return [
          wrappedOnQuestionPassed,
          wrappedOnQuestionFailed,
          match[2]
        ];
}

var BatchQuestions = {
  questions: questions,
  stateRef: stateRef,
  clearQuestions: clearQuestions,
  defer: defer,
  useMutationApi: useMutationApi$1
};

export {
  useMutationApi ,
  BatchQuestions ,
  
}
/* react Not a pure module */
